import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';

const { ItemGroup } = Menu;

const OrganisationMenu = ({ selectedKey, userRole }) => (
  <Menu
    mode="inline"
    inlineIndent={8}
    selectedKeys={[selectedKey]}
    className="sider-menu"
  >
    <Menu.Item key="/organization">
      <Link to="/organization">
        <Icon type="setting" aria-hidden />
        <span>Organisation Settings</span>
      </Link>
    </Menu.Item>

    <ItemGroup key="strategic_contacts" title="Strategic Contacts">
      <Menu.Item key="/organization/contacts">
        <Link to="/organization/contacts">
          <Icon type="contacts" aria-hidden />
          <span>Internal Contacts</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/customers">
        <Link to="/organization/customers">
          <Icon type="shopping-cart" aria-hidden />
          <span>Strategic Customers</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/suppliers">
        <Link to="/organization/suppliers">
          <Icon type="car" aria-hidden />
          <span>Strategic Suppliers</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/strategic-third-parties">
        <Link to="/organization/strategic-third-parties">
          <Icon type="team" aria-hidden />
          <span>Strategic Third Parties</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/strategic-crisis-experts">
        <Link to="/organization/strategic-crisis-experts">
          <Icon type="solution" aria-hidden />
          <span>Strategic Crisis Experts</span>
        </Link>
      </Menu.Item>
    </ItemGroup>

    <ItemGroup key="resources" title="Resources">
      <Menu.Item key="/organization/strategic-areas">
        <Link to="/organization/strategic-areas">
          <Icon type="environment" aria-hidden />
          <span>Strategic Areas</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/policy">
        <Link to="/organization/policy">
          <Icon type="file-text" aria-hidden />
          <span>Business Continuity Policy</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/plans">
        <Link to="/organization/plans">
          <Icon type="schedule" aria-hidden />
          <span>Plans</span>
        </Link>
      </Menu.Item>
      {userRole && (userRole === 'owner' || userRole === 'broker') && (
        <Menu.Item key="/organization/users">
          <Link to="/organization/users">
            <Icon type="team" aria-hidden />
            <span>Users</span>
          </Link>
        </Menu.Item>
      )}
    </ItemGroup>
  </Menu>
);

export default OrganisationMenu;
